import { createContext } from 'react';
import type { Actions } from '../actions/useArTableActions';

export type ArTableActionsContextValue = Actions;

export const ArTableActionsContext = createContext<ArTableActionsContextValue | null>(
  null
);


